import angular from 'angular';

// Translations
import translation from '../../../../../lib/translation';

// Load all services
import '../../../../../lib/service';

// Component
import component from './secondaryClaimEditor.component';

// Dependencies
// bootstrap-ui-datetime-picker dependencies
import 'angular-ui-bootstrap/src/datepickerPopup';
import 'angular-ui-bootstrap/src/datepicker';
import 'angular-ui-bootstrap/src/timepicker';
import 'bootstrap-ui-datetime-picker';
import 'ng-file-upload';
import errorList from '../../../../../lib/components/errorList';
import documentThumbnail from '../../../../../lib/components/documentThumbnail';
import isolateFormModule from '../../../../../lib/directives/isolateForm';

const moduleName = 'staff.dashboardScreen.secondaryClaimEditor';
let module = angular.module(moduleName, [
  translation,
  'ui.bootstrap',
  'ui.bootstrap.datetimepicker',
  'ngFileUpload',
  errorList.name,
  documentThumbnail.name,
  isolateFormModule.name,
]);

module.directive('validFile',function($parse){
  return {
      require:'ngModel',
      link:function(scope,el,attrs,ctrl){
          ctrl.$setValidity('validFile', el.val() != '');
          let p = $parse(attrs.ngModel);
          let hasUploadedDoc = p(scope);

          ctrl.$setValidity('validFile', el.val() != '' || !!(hasUploadedDoc && hasUploadedDoc.id));
          //change event is fired when file is selected
          el.bind('change',function(){

              ctrl.$setValidity('validFile', el.val() != '');
              scope.$apply(function(){
                  ctrl.$setViewValue(el.val());
                  ctrl.$render();
              });
          });
      }
  }
})
module.component('secondaryClaimEditor', component);

export default module;
